module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1523-11c2ddbfd2b6e34d7a72a3a6f6c129ce.png";